export default __webpack_public_path__ + "static/lifeprint-archit-1-b6324c77fc7d74f5c1c11e931bb55669.webp";